import { STAFF_ORDER_TYPE, STAFF_TYPE_IDS } from '@/constants/orderTypes'
import { parseDateRange } from '@/utils/date'

// === Константы ===
const DATE_START_FORMAT = 'YYYY-MM-DDT00:00:00'
const DATE_END_FORMAT = 'YYYY-MM-DDT23:59:59'

// === Маппинг: имя параметра в UI → имя параметра в API ===
// Для простых полей, где имя совпадает 1-в-1
const SIMPLE_PARAM_MAP = {
    status: 'status',
    num: 'num',
    price: 'price',
    price_min: 'price_min',
    price_max: 'price_max',
    brand: 'brand',
    courier_id: 'courier_id',
    sort_by: 'sort_by',
    order_by: 'order_by',
    phone: 'phone',
    guest: 'guest',
    address: 'address',
    dep_id: 'dep_id',
    type: 'filter[type]',
    shift_id: 'filter[shift_id]',
}

// === Маппинг: имя параметра в UI → другое имя в API ===
const RENAMED_PARAM_MAP = {
    transaction: 'transaction_id',
    division: 'dep_id',
    operator: 'operator_id',
    externalNum: 'ext_id',
}

const SPECIAL_HANDLERS = {
    orderType: value => {
        const typeIds = value === STAFF_ORDER_TYPE ? STAFF_TYPE_IDS : [value]
        return typeIds.map(id => ['type_id', id])
    },

    'order-date': value => {
        const { start, end } = parseDateRange(value)
        const result = []
        if (start) result.push(['start', start.format(DATE_START_FORMAT)])
        if (end) result.push(['end', end.format(DATE_END_FORMAT)])
        return result
    },

    orderCreatePeriod: value => SPECIAL_HANDLERS['order-date'](value),

    delivered_date: value => {
        const { start, end } = parseDateRange(value)
        const result = []
        if (start)
            result.push([
                'filter[start_delivery]',
                start.format(DATE_START_FORMAT),
            ])
        if (end)
            result.push(['filter[end_delivery]', end.format(DATE_END_FORMAT)])
        return result
    },

    divisions: value => {
        if (!Array.isArray(value) || !value.length) return []
        return [['filter[divisions]', value.join(',')]]
    },

    statuses: value => {
        if (!Array.isArray(value) || !value.length) return []
        return [['statuses', value.join(',')]]
    },

    deps: value => {
        if (!Array.isArray(value) || !value.length) return []
        return [['deps', value.join(',')]]
    },

    types_exclude: value => {
        if (!Array.isArray(value) || !value.length) return []
        return [['filter[exclude_type_id]', value.join(',')]]
    },
}

// === Основная функция ===

/**
 * Строит query string для запроса списка заказов
 * @param {Object} params - Параметры фильтра из UI
 * @param {string} [guestId] - Опциональный ID гостя
 * @returns {string} Query string (без ведущего '?')
 */
export const buildOrdersQueryString = (params, guestId) => {
    if (!params) return ''

    const queryParts = []

    // Вспомогательная проверка на "пустое" значение
    const hasValue = value => {
        if (value === undefined || value === null || value === '') return false
        if (Array.isArray(value) && value.length === 0) return false
        return true
    }

    // 1. Простые параметры
    Object.entries(SIMPLE_PARAM_MAP).forEach(([uiKey, apiKey]) => {
        if (hasValue(params[uiKey])) {
            queryParts.push([apiKey, params[uiKey]])
        }
    })

    // 2. Переименованные параметры
    Object.entries(RENAMED_PARAM_MAP).forEach(([uiKey, apiKey]) => {
        if (hasValue(params[uiKey])) {
            queryParts.push([apiKey, params[uiKey]])
        }
    })

    // 3. Специальные обработчики
    Object.entries(SPECIAL_HANDLERS).forEach(([uiKey, handler]) => {
        if (hasValue(params[uiKey])) {
            const pairs = handler(params[uiKey], params)
            queryParts.push(...pairs)
        }
    })

    // 4. guestId
    if (guestId) {
        queryParts.push(['guest_id', guestId])
    }

    // 5. Собираем через URLSearchParams
    const searchParams = new URLSearchParams()
    queryParts.forEach(([key, value]) => {
        searchParams.append(key, value)
    })

    const queryString = searchParams.toString()
    return queryString ? `&${queryString}` : ''
}
